import { Router } from '@angular/router';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IgnoreUrlPost, IgnoreUrlPut, IgnoreUrlDelete } from '../functions/ignor-url-toast.function';
import { CommonService } from '../services/common.service';
import { IsIgnoreUrlForLoading } from '../functions/ignor-url-loadding.function';
import { RemoveLocalStroge } from '../functions/local-storage.function';


/**
 * This interceptor use for user authentication and permissions.
 */
@Injectable({
  providedIn: 'root'
})
export class SnackarInterceptor implements HttpInterceptor {

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let errorReq = false;
    if ((req.method === 'POST' ||
      req.method === 'PUT' ||
      req.method === 'DELETE') &&
      IsIgnoreUrlForLoading(req)
    ) {
      this.commonService.changeStateLodding(true);
    }
    return next.handle(req).pipe(
      catchError((error, caught) => {
        errorReq = true;
        this.commonService.changeStateLodding(false);
        console.log('error?.error: ', error?.error);
        if ((error?.error?.message.includes('jwt'))
          || (error?.error?.message.includes('invalid'))
          || error?.error?.statusCode === 403) {
          this.commonService.showErrorSnackBar('شما زمان زیادی از سامانه استفاده نکردید.لطفا دوباره وارد شید');
          RemoveLocalStroge('login');
          this.router.navigate(['/auth/login']);
        } else if (error.message.includes('Unknown Error')) {
          this.commonService.showErrorSnackBar('خطا در برقراری ارتباط با سرور لطفا دقایقی دیگر مجددا تلاش کنید');
        } else {

          this.commonService.showErrorSnackBar(error.error.message || error.message);
        }
        return throwError(error);
      }),
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.commonService.changeStateLodding(false);
          if (req.method === 'POST' &&
            !errorReq &&
            IgnoreUrlPost(req)) {
            this.commonService.showSnackBar(event.body.message || 'با موفقیت ثبت شد!');
          }
          if (req.method === 'PUT' &&
            IgnoreUrlPut(req) && !errorReq) {
            this.commonService.showSnackBar(event.body.message || 'با موفقیت ویرایش شد!');
          }
          if (req.method === 'DELETE' && !errorReq &&
            IgnoreUrlDelete(req)) {
            this.commonService.showSnackBar(event.body.message || 'با موفقیت حذف شد!');
          }
        }
      })
    );
  }
}
